import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // マウント時に再取得するが、同じ画面にいる間は短時間のキャッシュを維持する。
      // staleTime: 0 だと編集中にバックグラウンドリフェッチが走りグリッドが
      // 破棄→再構築されてドロップダウンやセル参照がずれる問題があったため、
      // 30秒のキャッシュを設ける。画面遷移時（マウント時）は30秒以上経過して
      // いれば自動的に最新を取得する。
      staleTime: 30 * 1000, // 30 seconds
      refetchOnMount: 'always',
      // 401（認証エラー）ではリトライしない。axiosのリフレッシュインターセプターが
      // トークン更新を試み、失敗時は /login へリダイレクトするため、React Query の
      // リトライは無意味かつ白画面の原因になる。
      retry: (failureCount, error) => {
        const status = (error as any)?.response?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
